<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>

    <div v-if="usersWithActiveCourses.length > 0" class="mt-8">
      <div class="mb-4 flex items-center justify-between">
        <p class="text-lg font-semibold">
          Total cursuri active: {{ totalActiveCourses }}
        </p>
        <div class="w-64">
          <FloatLabel>
            <Select
              id="course_filter"
              v-model="selectedCourse"
              :options="courseOptions"
              option-label="label"
              option-value="value"
              class="w-full"
              :show-clear="true"
              @change="onCourseChange"
            />
            <label for="course_filter">Curs</label>
          </FloatLabel>
        </div>
      </div>
      <div class="overflow-x-auto rounded-sm bg-white shadow-sm">
        <DataTable
          :value="usersWithActiveCourses"
          :expanded-rows="expandedRows"
          data-key="id"
          striped-rows
          @row-expand="onRowExpand"
          @row-collapse="onRowCollapse"
        >
          <Column expander style="width: 3rem" />
          <Column field="name" header="Nume" sortable />
          <Column field="email" header="Email" sortable />
          <Column
            field="active_courses_count"
            header="Cursuri active"
            sortable
            style="width: 8rem"
          />
          <Column field="last_activity" header="Ultima activitate" sortable>
            <template #body="slotProps">
              {{ formatDateTime(slotProps.data.last_activity) }}
            </template>
          </Column>
          <template #expansion="slotProps">
            <div class="px-6 py-4 bg-gray-50 border-l-4 border-primary-color">
              <DataTable
                :value="slotProps.data.active_courses"
                size="small"
                class="shadow-sm"
              >
                <Column field="course_name" header="Curs" />
                <Column field="course_type" header="Tip" />
                <Column field="start_date" header="Start">
                  <template #body="courseSlot">
                    <div class="text-sm">
                      <span
                        :class="
                          courseSlot.data.rescheduled ? 'line-through' : ''
                        "
                      >
                        {{ formatDate(courseSlot.data.start_date) }}
                      </span>
                      <span v-if="courseSlot.data.rescheduled" class="block">
                        {{ formatDate(courseSlot.data.restart_start_date) }}
                      </span>
                    </div>
                  </template>
                </Column>
                <Column field="end_date" header="Sfârșit">
                  <template #body="courseSlot">
                    <div class="text-sm">
                      <span
                        :class="
                          courseSlot.data.rescheduled ? 'line-through' : ''
                        "
                      >
                        {{ formatDate(courseSlot.data.end_date) }}
                      </span>
                      <span v-if="courseSlot.data.rescheduled" class="block">
                        {{ formatDate(courseSlot.data.restart_end_date) }}
                      </span>
                    </div>
                  </template>
                </Column>
                <Column field="completion" header="Progres" style="width: 4rem">
                  <template #body="courseSlot">
                    <span v-if="courseSlot.data.completion !== null">
                      {{ courseSlot.data.completion }}%
                    </span>
                    <span v-else class="text-gray-400">-</span>
                  </template>
                </Column>
              </DataTable>
            </div>
          </template>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import { router } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import * as timeago from 'timeago.js';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';
import { formatDate, formatStatus, formatDateTime } from '@/utils/formatters';

export default {
  components: {
    Head,
    DataTable,
    Column,
    Select,
    FloatLabel,
  },
  layout: Layout,
  props: {
    git: {
      type: Object,
      required: true,
    },
    usersWithActiveCourses: {
      type: Array,
      default: () => [],
    },
    totalActiveCourses: {
      type: Number,
      default: 0,
    },
    courses: {
      type: Array,
      default: () => [],
    },
    selectedCourseId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      expandedRows: [],
      selectedCourse: this.selectedCourseId,
      courseOptions: [
        ...this.courses.map((c) => ({ label: c.name, value: c.id })),
      ],
    };
  },
  computed: {
    relativeCommitTime() {
      return timeago.format(this.git.commit_time);
    },
  },
  methods: {
    formatDate,
    formatStatus,
    formatDateTime,
    onRowExpand(event) {
      console.log('Row expanded:', event.data);
    },
    onRowCollapse(event) {
      console.log('Row collapsed:', event.data);
    },
    onCourseChange() {
      router.get(
        '/',
        { course_id: this.selectedCourse },
        { preserveState: false, preserveScroll: false },
      );
    },
  },
};
</script>
